angular.module("Main").filter("filterMultiple", function () {

    function filter(items, terminart, trainer, sonstige) {
        var result = [];

        if (terminart)
            if (terminart.length === 0 && trainer.length === 0 && sonstige.length === 0) {
                result = items;
            }
            else {
                if (terminart.length > 0) {
                    _.forEach(items, function (r) {
                        if (_.includes(terminart, r.Terminart_Nr)) {

                            result.push(r);
                        }
                        else {
                            _.pull(result, r)
                        }
                        if (trainer.length > 0) {
                            _.forEach(result, function (r) {
                                if (r.RessourcesNrs.length > 0) {
                                    if (terminart.length === 1) {
                                        _.forEach(trainer, function (tr) {
                                            if (r.RessourcesNrs.includes(tr)) {
                                                result.push(r);
                                            }
                                            else {
                                                _.pull(result, r)
                                            }
                                        })
                                    }
                                    else if (terminart.length > 1) {
                                       if(_.intersection(r.RessourcesNrs, trainer).length > 0) {
                                           result.push(r)
                                       } else {
                                           _.pull(result, r)
                                       }
                                    }
                                } else {
                                    _.pull(result, r)
                                }

                                if (sonstige.length > 0) {
                                    _.forEach(result, function (r) {
                                        if (_.includes(sonstige, 1)) {
                                            if (r.Teilnehmer >= r.MaximaleAnzahlTeilnehmer && r.Warteliste === 0) {
                                                _.pull(result, r);
                                            }
                                        }
                                        if (_.includes(sonstige, 2)) {
                                            if (r.Teilnehmer >= r.MaximaleAnzahlTeilnehmer && r.Warteliste !== 0) {
                                                _.pull(result, r);
                                            }
                                        }
                                    })
                                }
                            })
                        }
                    });

                }
                if (terminart.length === 0 && trainer.length > 0) {
                    _.forEach(items, function (r) {
                        if (r.RessourcesNrs.length > 0) {
                            _.forEach(trainer, function (tr) {
                                if (r.RessourcesNrs.includes(tr)) {
                                    result.push(r);
                                }
                                // else {
                                //     _.pull(result, r)
                                // }
                            })
                        } else {
                            _.pull(result, r)
                        }
                        if (sonstige.length > 0) {
                            _.forEach(result, function (r) {
                                if (_.includes(sonstige, 1)) {
                                    if (r.Teilnehmer >= r.MaximaleAnzahlTeilnehmer && r.Warteliste === 0) {
                                        _.pull(result, r);
                                    }
                                }
                                if (_.includes(sonstige, 2)) {
                                    if (r.Teilnehmer >= r.MaximaleAnzahlTeilnehmer && r.Warteliste !== 0) {
                                        _.pull(result, r);
                                    }
                                }
                            })
                        }
                    });
                }

                if (terminart.length === 0 && trainer.length === 0 && sonstige.length > 0) {
                    if (!_.isNil(items)) {
                        _.forEach(items, function (r) {
                            if (r.FreiePlaetze === 0) {
                                if (_.includes(sonstige, 1)) {
                                    if (r.Warteliste === 0) {
                                        _.pull(result, r);
                                    } else {
                                        result.push(r);
                                    }
                                }
                                if (_.includes(sonstige, 2)) {
                                    if (r.Warteliste !== 0) {
                                        _.pull(result, r);
                                    }
                                }
                            }
                            else {
                                result.push(r);
                            }
                        })
                    }
                }

            }
        return _.uniq(result);

    }

    return filter;
});